import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { approveMerchant as approveMerchantApi } from "../api/merchant.api";
import type { MerchantDetail } from "../types/merchant.types";

interface UseApproveMerchantReturn {
  approveMerchant: (id: string) => Promise<MerchantDetail>;
  loading: boolean;
  error: string | null;
}

export const useApproveMerchant = (): UseApproveMerchantReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const approveMerchant = useCallback(async (id: string): Promise<MerchantDetail> => {
    try {
      setLoading(true);
      setError(null);
      return await approveMerchantApi(id);
    } catch (approveError: unknown) {
      setError(getApiErrorMessage(approveError, "Failed to approve merchant"));
      throw approveError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { approveMerchant, loading, error };
};
